module.exports = __webpack_public_path__ + "6c4a0dbc/img/share-icon.0f8a11b4.svg";